import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator, setErrorsCreator } from './reducer';
import { importMaTrainingsCreator } from '../../../../../store/actionsCreators';
import ImportTraining from '../../../../../shared/Cpd/Trainings/Import/ImportTraining';

const ImportMaTraining = ({ importData, importErrors }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <ImportTraining
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setErrorsCreator={setErrorsCreator}
      importData={importData}
      importErrors={importErrors}
    />
  );
};

ImportMaTraining.propTypes = {
  importData: PropTypes.func.isRequired,
  importErrors: PropTypes.array,
};

ImportMaTraining.defaultProps = {
  importErrors: [],
};

const mapStateToProps = ({ ma }) => ({
  importErrors: ma.trainings.importErrors,
});

const mapDispatchToProps = (dispatch) => ({
  importData: (params) => dispatch(importMaTrainingsCreator(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportMaTraining);
